export const TagGroup_Prefix = 'TagGroup_';
export const TagGroup_Unassigned = 'TagGroup_Unassigned';

export type SectionColumnTagGroupType = `TagGroup_${string}`;

export function isSectionColumnTagGroupType(key: string): key is SectionColumnTagGroupType {
  return key.startsWith(TagGroup_Prefix);
}

export type SectionColumnConfigTagGroupKey = `TagGroup_${string}`;

export function isProductTagGroupKey(key: string): key is SectionColumnConfigTagGroupKey {
  return key.startsWith(TagGroup_Prefix);
}
